import React from "react";
import { RouteComponentProps } from "react-router";
import { checkIfDirectRoute } from "@utils/navigationUtils";
import { ACCOMMODATION_REQUEST_SLIDER } from "@navigation";
import { bonlivaPipelineTheme } from "@bonliva-crm/ui";
import { AccommodationRequestSearchFiltersProvider } from "./hooks/use-accommodation-request-search-filters";
import { Box, ThemeProvider } from "@material-ui/core";
import { AccommodationRequestSearchLayout } from "./accommodation-request-search-layout";

type Props = RouteComponentProps<any>;

export function AccommodationRequestSearchPage(props: Props) {
  const { match } = props;
  const { url } = match;
  return (
    <>
      {catchDirectUrl(url)}
      <ThemeProvider theme={bonlivaPipelineTheme}>
        <AccommodationRequestSearchFiltersProvider>
          <Box
            width="100%"
            height="100%"
            fontFamily={bonlivaPipelineTheme.typography.fontFamily}
          >
            <AccommodationRequestSearchLayout />
          </Box>
        </AccommodationRequestSearchFiltersProvider>
      </ThemeProvider>
    </>
  );
}

function catchDirectUrl(url) {
  return checkIfDirectRoute([`${url}/:accommodationRequestId(\\S{24})`], ACCOMMODATION_REQUEST_SLIDER, ({ accommodationRequestId }) => {
    if (accommodationRequestId) {
      // return new KitProfileLocation(kitId);
    }
  });
}
